import React from 'react'
import { FieldDescriptionsH4, Required } from './styles'

export const FieldDescriptions = () => (
  <React.Fragment>
    <FieldDescriptionsH4>Fields Description</FieldDescriptionsH4>{' '}
    <Required>All fields are required</Required>
    <ul>
      <li>
        SiteId: <i>The SS Id of the Site you want to add pacing dates to</i>
      </li>
      <li>
        Program Access Code:{' '}
        <i>
          **only <code>highschool</code> is available at this time
        </i>
      </li>
      <li>
        Training Start Date: <i>The training start date</i>
      </li>
      <li>
        Program Start Date:{' '}
        <i>The start date of the program **must be after training start date</i>
      </li>
      <li>
        School Year End: <i>The end date of the school year</i>
      </li>
    </ul>
  </React.Fragment>
)

export const InstructionsText = () => (
  <i>
    Upload your <code>.xlsx</code> or <code>.csv</code> in the format below.
  </i>
)

export const TitleSection = () => (
  <React.Fragment>
    <h2>Pacing Tool</h2>
    <hr />
    <h3>Tool Description</h3>
    <p>Create Pacing dates for multiple schools</p>
  </React.Fragment>
)
